import { useEffect } from 'react'
import StageMail from 'components/auth/register/StageMail'
import StageTypeSelection from 'components/auth/register/StageTypeSelection'
import StageBranch from 'components/auth/register/StageBranch'
import React, { useState } from 'react'
import {  useNavigate } from 'react-router-dom'
import { stages } from 'utils/Constants'
import StagePassword from 'components/auth/register/StagePassword'
import StageAddresses from 'components/auth/register/StageAdresses'
import StageTakeaway from 'components/auth/register/StageTakeaway'
import StageForgotStep1 from 'components/auth/register/StageForgotStep1'
import ChoiceBranch from 'components/auth/register/ChoiceBranch'
import StageAddAddresses from 'components/auth/register/StageAddAddresses'
import auth from 'utils/Auth'
import {useDispatch} from 'react-redux'
import {setCurrentStage} from 'redux/features/general/generalSlice'

const DeliveryTypeSelection = () => {
	const dispatch = useDispatch()
	const token = auth.isHaveToken()
	const [registerStage, setRegisterState] = useState(stages.STAGE_TYPE_SELECTION )
    const navigate = useNavigate()
	//const navigate = useNavigate();
	//const parameters = auth.getUserChoises();

	//   useEffect(() => {
	//       if(token && parameters?.deliveryType && parameters?.neighbourhoodId && parameters?.restaurantId){
	//          navigate('/')
	//       }
	//   },[location])

	useEffect(() => {
		window.scrollTo(0, 0)
		dispatch(setCurrentStage(registerStage))
	}, [registerStage])
    useEffect(() => {
        if (!token) {
            navigate('/')
        }
    },[token])
	const StageComponent = () => {
		switch (registerStage) {
			case stages.STAGE_TYPE_SELECTION:
				return <StageTypeSelection isLogin={true} setRegisterState={setRegisterState} />
			case stages.STAGE_CHOICE_BRANCH:
				return <ChoiceBranch setRegisterState={setRegisterState} />
			case stages.STAGE_ADDRESSES:
				return <StageAddresses setRegisterState={setRegisterState} />
			case stages.STAGE_ADD_ADDRESS:
				return <StageAddAddresses forHome setRegisterState={setRegisterState} />
			case stages.STAGE_BRANCH:
				return <StageBranch forHome setRegisterState={setRegisterState} />
			case stages.STAGE_NEWLOGIN:
				return <StagePassword setRegisterState={setRegisterState} />
			case stages.STAGE_TAKEAWAY:
				return <StageTakeaway setRegisterState={setRegisterState} />
			case stages.STAGE_FORGOTSTEP1:
				return <StageForgotStep1 setRegisterState={setRegisterState} />
			default:
				return <StageMail setRegisterState={setRegisterState} />
		}
	}
	return (
		<div className={`register ${registerStage == stages.STAGE_TAKEAWAY ? 'pt-0' : ''}`}>
			<StageComponent />
		</div>
	)
}

export default DeliveryTypeSelection
